import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import { Can } from "src/helpers/Auth";

import { Avatar } from "@mui/material";
import CIcon from "@coreui/icons-react";
import { LogOutComponent } from "../views/pages/login/Login";
import React from "react";
import { stringAvatar } from "src/helpers/helperFunctions";
import { useGetUserDetails } from "src/helpers/UserDetails";
import { useHistory } from "react-router-dom";

const TheHeaderDropdown = () => {
  const [logoutClicked, setLogoutClicked] = React.useState(false);

  const history = useHistory();
  const user = useGetUserDetails();

  const handleUserProfileClick = () => {
    history.push("/userprofile");
  };

  const handleOAuthClick = () => {
    history.push("/oauth");
  };

  return (
    <CDropdown
      inNav
      className="c-header-nav-items mx-2"
      direction="down"
      data-testid="hdr-btn-user-menu"
    >
      <CDropdownToggle
        className="c-header-nav-link"
        caret={false}
        data-attr="header:btn:open-user-menu"
      >
        <div className="d-flex gap-2 align-items-center">
          {user && (
            <Avatar
              {...stringAvatar(user?.user_display_name)}
              style={{ width: "30px", height: "30px" }}
              size="large"
            ></Avatar>
          )}
          {user?.user_display_name}
        </div>
      </CDropdownToggle>

      <CDropdownMenu className="pt-0 pb-0" placement="bottom-end">
        <CDropdownItem
          data-testid="hdr-menuitem-profile"
          data-attr="header:link:view-profile"
          onClick={handleUserProfileClick}
          id="profile-dropdown-link"
          style={{ paddingTop: "10px", paddingBottom: "10px" }}
        >
          <CIcon name="cil-user" className="mfe-2" />
          Profile
        </CDropdownItem>
        <Can
          perform={"admin"}
          key={"oauth-settings"}
          yes={() => (
            <CDropdownItem
              data-testid="hdr-menuitem-oauth"
              data-attr="header:link:oauth-settings"
              onClick={handleOAuthClick}
              id="oauth-dropdown-link"
              style={{ paddingTop: "10px", paddingBottom: "10px" }}
            >
              <CIcon name="cil-user" className="mfe-2" />
              OAuth Settings
            </CDropdownItem>
          )}
          no={() => {
            return <></>;
          }}
        />
        <CDropdownItem
          data-testid="hdr-menuitem-logoff"
          data-attr="header:btn:logout"
          style={{ paddingBottom: "10px" }}
          onClick={() => setLogoutClicked(true)}
        >
          <CIcon name="cil-lock-locked" className="mfe-2" />
          <LogOutComponent clicked={logoutClicked} />
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default TheHeaderDropdown;
